import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TaskParticipantsPage } from './task-participants.page';
import { TranslateModule } from '@ngx-translate/core';
import { UserPhotoPageModule } from '../components/user-photo/user-photo.module';

const routes: Routes = [
    {
        path: '',
        component: TaskParticipantsPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule,
        UserPhotoPageModule
    ],
    declarations: [TaskParticipantsPage]
})
export class TaskParticipantsPageModule {}
